import { render, staticRenderFns } from "./waterVolumnDetail.vue?vue&type=template&id=629f929d"
import script from "./waterVolumnDetail.vue?vue&type=script&lang=js"
export * from "./waterVolumnDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629f929d')) {
      api.createRecord('629f929d', component.options)
    } else {
      api.reload('629f929d', component.options)
    }
    module.hot.accept("./waterVolumnDetail.vue?vue&type=template&id=629f929d", function () {
      api.rerender('629f929d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/water/waterVolumnDetail.vue"
export default component.exports